import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.34 7.02L20.76 5.6L19.35 4.19L18.03 5.51C16.74 4.3 15.15 3.49 13.43 3.14V2H9.64V3.14C5.28 4.02 2 7.87 2 12.47C2 17.72 6.27 22 11.53 22C16.79 22 21.06 17.73 21.06 12.47C21.06 10.51 20.46 8.61 19.35 7.02H19.34ZM11.53 20C7.38 20 4 16.62 4 12.47C4 8.32 7.38 4.94 11.53 4.94C13.73 4.94 15.82 5.9 17.25 7.58C18.41 8.94 19.05 10.67 19.05 12.47C19.05 16.62 15.67 20 11.52 20H11.53ZM10.53 7.26H12.53V13.42H10.53V7.26Z" fill={ fill || 'currentColor' } />
    </svg>
);
